import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logout } from "./authSlice";

export interface AppDataState {
    page: { header: string };
}

const initialState: AppDataState = {
    page: { header: '' }
};


const appDataSlice = createSlice({
    name: "appData",
    initialState,
    reducers: {

        setPageHeader: (
            state,
            action: PayloadAction<string>
        ) => {
            state.page.header = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            console.log("User logged out, resetting appDataSlice state.");
            return initialState; // Reset state on logout
        }); 
    }
});

export const { setPageHeader } = appDataSlice.actions;
export default appDataSlice.reducer;
